import { __ } from '@wordpress/i18n';
import { RawHTML } from '@wordpress/element';
import { Modal, Button } from '@wordpress/components';
import { lock } from '@wordpress/icons';

export const ModalPromo = ({onRequestClose}) => {
	return (
		<Modal
			title={ __( 'PRO feature', 'popper' ) }
			onRequestClose={ onRequestClose }
		>
			<RawHTML>
				{ sprintf(
					/* translators: Link to site. */
					// eslint-disable-next-line @wordpress/i18n-no-collapsible-whitespace, @wordpress/i18n-translator-comments
					__(
						`<p>Sorry, this is a PRO feature. With %s you can add mail services integrations <br />
						(Mailchimp, ConvertKit, MailPoet, GetResponse and more…) to your popups.</p>
						<p>You can also send data to Google Sheets or to webhooks and more.</p>
						<p>Please upgrade to the PRO plan to unlock all these awesome features.</p>`,
						'popper'
					),
					`<a href="https://www.popperwp.com/" target="_blank">Popper Pro</a>`
				) }
			</RawHTML>
			<Button
				variant="primary"
				href="https://www.popperwp.com/"
				icon={ lock }
				iconPosition={ 'left' }
				target="_blank"
				size="compact"
			>
				{ __( 'Upgrade to PRO', 'popper' ) }
			</Button>
		</Modal>
	);
}